export default "__VITE_ASSET__a0b1be6b__"